import React, { useEffect, useRef } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Container } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";

const SendCreditOtpModal = ({ showModal, setshowModal, timer, setTimer, setIsTimerActive, isTimerActive, email, loading, transferFunc ,setOtp, otp, otpIs, setOtpIs, sendCreditTransfer}) => {

    const inputRefs = useRef([]);

    useEffect(() => {
        let countdown;
        if (isTimerActive && timer > 0) {
            countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (timer === 0) {
            clearInterval(countdown);
            setIsTimerActive(false);
        }
        return () => clearInterval(countdown);
    }, [isTimerActive, timer]);

    const handleOtpChange = (value, index, otpType) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value.length === 1 && index < newOtp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index, otpType) => {
        const currentOtp = otp;
        if (e.key === "Backspace" && currentOtp[index] === '' && index > 0) {
            const newOtp = [...currentOtp];
            newOtp[index - 1] = '';
            setOtp(newOtp);
            inputRefs.current[index - 1].focus();
        }
    };

    useEffect(() => {
        const otpValue =  otp.join('');
        setOtpIs(otpValue);
    }, [otp]);

    const verifyOtpForVerification = async () => {
        if (otpIs.length === 0) {
            toast.error('OTP is required');
            return;
        }
        try {
           transferFunc()

        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Modal
            show={showModal}
            onHide={() => setshowModal(false)}
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center">
                    <h5 className="mb-0">Credit Transfer Verification</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container className='d-flex flex-column justify-content-center align-items-center'>
                        <p className='text-center'>Enter the 4-digit OTP sent to your registered email <strong>{email}</strong></p>
                    <Row className="mb-4 d-flex justify-content-center">
                        {otp.map((value, index) => (
                            <Col key={index} xs={2} className='d-flex justify-content-center align-items-center'>
                                <Form.Control
                                    type="text"
                                    maxLength="1"
                                    value={value}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    className='text-center'
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (/^\d*$/.test(inputValue)) {
                                            handleOtpChange(inputValue, index);
                                        }
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                />
                            </Col>
                        ))}
                    </Row>
                    <p className="text-center mb-4">Time remaining: {timer} seconds</p>
                     <p className='text-center'>This OTP is required to verify your credit <strong>Transfer request</strong></p>
                    <Button
                        variant="main2"
                        className="text-white w-50"
                        style={{ height: 45 }}
                        onClick={isTimerActive ? verifyOtpForVerification : () => {
                            setIsTimerActive(true);
                            setTimer(60);
                            sendCreditTransfer();
                        }}
                    >
                        {isTimerActive ? "Verify OTP" : loading ? (
                            <Spinner animation="border" size="sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        ) : "Resend OTP"}
                    </Button>
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export default SendCreditOtpModal;
